/** every route rendered by AuthLayout (login, 2FA, password flows) sits under this */
export const AUTH_ROUTE_PREFIX = "/auth";

export const appPaths = {
  login: "/auth/login",
  forgotPassword: "/auth/forgot-password",
  resetPassword: "/auth/reset-password",
  setPassword: "/auth/set-password",
  twoFactorAuth: "/auth/2fa",

  // logout: "/auth/logout",
  settings: "/app/settings",
  settingsAuditLog: "/app/settings/audit-log",
  tenantSettingsRolesAndResponsibility: "/app/settings/roles-responsibility",

  tenantSettings: "/app/tenant-settings",
  tenantSettingsAdminUsers: "/app/tenant-settings/admin-users",
  tenantSettingsTenantConfiguration:
    "/app/tenant-settings/tenant-configuration",

  libraryPath: "/app/library",
  libraryCatalogPath: "/app/library/catalog",

  libraryCatalogLOINCCodePath: "/app/library/catalog",
  libraryCatalogDrugCatalogPath: "/app/library/catalog/drug-catalog",
  libraryCatalogICDTenCodePath: "/app/library/catalog/diagnosis-catalog",
  libraryCatalogCPTCodePath: "/app/library/catalog/cpt-code-catalog",
  libraryCatalogHCPCSCodePath: "/app/library/catalog/hcpcs-code-catalog",

  libraryFormBuilderPath: "/app/library/form-builder-list",
  libraryProviderFormBuilderPath: "/app/provider/library/form-builder",

  libraryTemplatesPath: "/app/library/templates-list",

  adminUsersPagePath: "/app/settings/user-settings",
  adminRoleAndResponsibilityPath:
    "/app/settings/user-settings/role-responsibility",

  staffUsersPagePath: "/app/provider/settings/user-settings",
  providerUsersPagePath: "/app/provider/settings/user-settings/provider-users",
  providerRoleAndResponsibilityPath:
    "/app/provider/settings/user-settings/role-responsibility",
  dashboardPath: "/app/dashboard",
  providerGroupsPath: "/app/provider-groups",
  // providerGroupsProfile: "/app/provider-groups/1",
  // providerGroupsLocations: "/app/provider-groups/1/locations",
  // providerGroupsDepartments: "/app/provider-groups/1/departments",
  // providerGroupsPatients: "/app/provider-groups/1/patients",
  // providerGroupsUsers: "/app/provider-groups/1/users",
  providerLocationDetails: "/app/provider-groups/location-id",
  providerLocationDepartment: "/app/provider-groups/location-id/department",
  providerLocationPatient: "/app/provider-groups/location-id/patient",
  providerLocationUser: "/app/provider-groups/location-id/user",
  staffUser: "/app/provider-groups/users/staff/1",
  providerUser: "/app/provider-groups/users/provider/1",
  schedulingAppointment: "/app/provider/scheduling/appointment",
  ENCOUNTER: "/app/provider/encounter",
  schedulingCalendar: "/app/provider/scheduling",
};

export const PROVIDER_PATHS = {
  DASHBOARD: "/app/provider/dashboard",
  CALENDER: "/app/provider/scheduling",
  APPOINTMENTS: "/app/provider/scheduling/appointment",
  AVAILABILITY: "/app/provider/scheduling/availability",
  GROUP_APPOINTMENTS: "/app/provider/scheduling/appointment/group",
  OPEN_TASKS: "/app/provider/scheduling/open-task",
  APPOINTMENT_STATUS: "/app/provider/scheduling/appointment-status",
  VISIT_TEMPLATES: "/app/provider/library/visit-templates",
  // REFERRALS: "/app/provider/scheduling/referrals",

  // Patients
  PATIENT_LIST: "/app/provider/patients",
  GROUP_VISIT: "/app/provider/group-visit",
  GROUP_CHECK_IN: "/app/provider/group-visit/check-in",
  GROUP_SESSION_NOTE: "/app/provider/group-visit/session-note",
  PATIENT_DETAIL: "/app/provider/patients/1",
  PATIENT_FLAGS: "/app/provider/patients/flags",
  CONSENT_FORM: "/app/provider/patients/consent-forms",

  //Communications
  COMMUNICATION: "/app/provider/communications",
  INCOMING_FAX: "/app/provider/communications/fax",
  MESSAGES: "/app/provider/communications",

  CHAT: "/app/provider/communications/chat",
  EMAIL: "/app/provider/communications/email",
  FAX: "/app/provider/communications/fax",
  DICTIONARY: "/app/provider/communications/dictionary",

  // Billing
  BILLING: "/app/provider/billing/",
  SUPER_BILL: "/app/provider/billing/invoice",
  CLAIMS: "/app/provider/billing/claims",
  ERA_EOB_DETAIL: "/app/provider/billing/era-eob",
  PAYMENTS:
    "/app/provider/billing/payments?activePatientPayment=patient-payment",
  ACCOUNT_RECEIVABLE: "/app/provider/billing/account-receivable/summary",
  FEE_SCHEDULE: "/app/provider/billing/fee-schedule",
  CLINICAL_REPORTS: "/app/provider/reports",
  BILLING_REPORTS: "/app/provider/reports/billing-reports",

  // Settings
  ACCOUNT_SETTINGS: "/app/provider/settings/account-settings",
  FLAG_SETTINGS: "/app/provider/settings/flag-settings",
  PATIENT_FLAG_SETTINGS:
    "/app/provider/settings/flag-settings/patient-flag-settings",
  PRACTICE_SETTING: "/app/provider/settings/practice-settings",
  USER_SETTINGS: "/app/provider/settings/user-settings",
  PROVIDER_ADMIN_SETTING: "/app/provider/settings/account-settings",
  MASTERS: "/app/provider/settings/account-settings",
  ERX_SETTING: "/app/provider/settings/account-settings",

  //Collaboration
  TASKS: "/app/provider/collaboration/tasks?activeTask=patient-centric-tasks",
  REFERRALS: "/app/provider/collaboration/referrals?activeReferral=referral-in",
  PATIENT_INQUIRIES: "/app/provider/collaboration/patient-inquiries",
  REFILL_REQUEST: "/app/provider/collaboration/refill-request",
  RESULTS: "/app/provider/collaboration/results",
  OPEN_ENCOUNTERS: "/app/provider/collaboration/open-encounters",
  ASSESSMENTS: "/app/provider/collaboration/assessments",

  // Library
  LIBRARY: "/app/provider/library",
  LIBRARY_CATALOG: "/app/provider/library/catalog",

  libraryCatalogLOINCCodePath: "/app/provider/library/catalog/",
  libraryCatalogDrugCatalogPath: "/app/provider/library/catalog/drug-catalog",
  libraryCatalogICDTenCodePath:
    "/app/provider/library/catalog/diagnosis-catalog",
  libraryCatalogCPTCodePath: "/app/provider/library/catalog/cpt-code-catalog",
  libraryCatalogHCPCSCodePath:
    "/app/provider/library/catalog/hcpcs-code-catalog",
  LIBRARY_FORM_BUILDER: "/app/provider/library/form-builder",
  LIBRARY_TEMPLATES: "/app/provider/library/templates",
  LIBRARY_EDUCATION_MATERIAL: "/app/provider/library/education-material",

  // Visit Note
  NEW_PATIENT: "/app/provider/patients/new-patient",
};

/**
 * Deep-links Communications › SMS/Text to one patient's thread, so the Dashboard
 * Messages widget can open the conversation it was clicked on.
 */
export const SMS_THREAD_PATIENT_PARAM = "patientId";

const PATIENT_NEW_PATIENT_PATH = "/app/provider/patients/new-patient";
export const PATIENT_NEW_PATIENT_INDEX_PATH = (patientId: string) =>
  `${PATIENT_NEW_PATIENT_PATH}/${patientId}/index`;

export const PATIENT_PATHS = {
  DASHBOARD: "/app/patient/dashboard",
  HOME: "/app/patient/home",
  INTAKE: "/app/patient/intake",
  APPOINTMENTS: "/app/patient/appointments",
  APPOINTMENT: "/app/patient/appointment",
  FORMS: "/app/patient/forms",
  PROVIDERS: "/app/patient/providers",
  COMMUNICATION: "/app/patient/communication",
  BILLING: "/app/patient/billing",
  DOCUMENTS: "/app/patient/documents",
  HEALTH_RECORD: "/app/patient/health-record",
  SETTINGS: "/app/patient/settings",
  VISITS: "/app/patient/health-record/past-visit",
  PAYMENTS: "/app/patient/billing",
  REPORTS: "/app/patient/health-record/order/reports",
  TASKS: "/app/patient/tasks",
};
